module.exports = __webpack_public_path__ + "static/media/Icons_winning_outcome.0dde914b.svg";